<!-- Start Containerbar -->
<div id="containerbar" class="containerbar authenticate-bg">
  <p-toast></p-toast>
  <!-- Start Container -->
  <div class="container">
    <div class="auth-box login-box">
      <!-- Start row -->
      <div class="row no-gutters align-items-center justify-content-center">
        <!-- Start col -->
        <div class="col-md-6 col-lg-5">
          <!-- Start Auth Box -->
          <div class="auth-box-right">
            <div class="card">
              <div class="card-body">
                <form
                  class="update-form"
                  [formGroup]="updateForm"
                  (ngSubmit)="onpasswordUp()"
                >
                  <div class="form-head">
                    <a class="logo"
                      ><img
                        src="assets/images/logo.svg"
                        class="img-fluid"
                        alt="logo"
                    /></a>
                  </div>
                  <h4 class="text-primary my-4">Update Password</h4>
                  <div class="form-group">
                    <div style="text-align: center">
                      <div class="form-group">
                        <div class="form-input">
                          <input
                            [type]="showPassword ? 'text' : 'password'"
                            class="form-control"
                            id="password-field"
                            placeholder="Password"
                            required
                            formControlName="password"
                            [ngClass]="{
                              'is-invalid': submitted && f.password.errors
                            }"
                          /><span class="icon">
                            <i
                              class="fa"
                              [ngClass]="{
                                'fa-eye-slash': !showPassword,
                                'fa-eye': showPassword
                              }"
                              (click)="toggleFieldTextType()"
                            ></i
                          ></span>
                        </div>
                        <div
                          *ngIf="submitted && f.password.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f.password.errors.required">
                            Please enter password
                          </div>
                          <div *ngIf="f.password.errors.pattern">
                            Minimum 8 characters, at least 1 uppercase letter, 1
                            lowercase letter, 1 number and 1 special character
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <div style="text-align: center">
                      <div class="form-group">
                        <div class="form-input">
                          <input
                            [type]="hide ? 'text' : 'password'"
                            class="form-control"
                            id="confirmpassword"
                            placeholder="Confirm Password"
                            required
                            formControlName="confirmPassword"
                            [ngClass]="{
                              'is-invalid':
                                submitted && f.confirmPassword.errors
                            }"
                          /><span class="icon">
                            <i
                              class="fa"
                              id="confPass"
                              [ngClass]="{
                                'fa-eye-slash': !hide,
                                'fa-eye': hide
                              }"
                              (click)="togglePasswordType()"
                            ></i
                          ></span>
                        </div>

                        <div
                          *ngIf="submitted && f.confirmPassword.errors"
                          class="invalid-feedback"
                        >
                          <div *ngIf="f.confirmPassword.errors.required">
                            Please reenter the Password
                          </div>
                          <div *ngIf="f.confirmPassword.errors.mustMatch">
                            Passwords must match
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    class="btn btn-primary-rgba btn-lg btn-block font-18"
                    [disabled]="disableBtn"
                  >
                    Update Password
                  </button>
                </form>
              </div>
            </div>
          </div>
          <!-- End Auth Box -->
        </div>
        <!-- End col -->
      </div>
      <!-- End row -->
    </div>
  </div>
  <!-- End Container -->
</div>
<!-- End Containerbar -->
